import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideAuth0, authHttpInterceptorFn } from '@auth0/auth0-angular';
import { environment } from '../environments/environment';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
	provideAuth0({
		domain: environment.domain,
		clientId: environment.clientId,
		authorizationParams: {
			redirect_uri: window.location.origin,
			audience: environment.audience
		},
		httpInterceptor: {
			allowedList: [
				{
					uri: environment.apiUrl + '/*',
					tokenOptions: {
						authorizationParams: {
							audience: environment.audience
						}
					}
				}
			]
		}
	}),
	provideZoneChangeDetection({ eventCoalescing: true }),
	provideRouter(routes),
	provideAnimationsAsync(),
	provideHttpClient(withInterceptors([authHttpInterceptorFn]))]
};
